import { render, staticRenderFns } from "./ItemHome.vue?vue&type=template&id=107214da"
import script from "./ItemHome.vue?vue&type=script&lang=js"
export * from "./ItemHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports